<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <toast></toast>
    <loading :loading="loadingShow"></loading>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Loading from './components/Loading.vue';
import Toast from './components/Toast.vue';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    Loading,
    Toast,
    Header,
    Footer,
  },
  computed: {
    ...mapState([
      'loadingShow',
      'pageShow',
      'clickRecharge',
    ]),
  },
  watch: {
    pageShow(e) {
      if (this.clickRecharge && e) {
        this.getUserInfoFn();
      }
    },
  },
  mounted() {
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        // 页面被挂起
        this.setState({ pageShow: false });
      } else {
        // 页面呼出
        this.setState({ pageShow: true });
      }
    });
  },
  methods: {
    ...mapActions([
      'getUserInfoFn',
    ]),
    ...mapMutations([
      'setState',
    ]),
  },
};
</script>

<style lang="scss" scope>
* {
}
#app {
  width: 100%;
  height: 100%;
}
</style>
